// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React, { useContext } from 'react'
import { array, node, string } from 'prop-types'
import { Link } from 'react-router-dom'
import { AuthContext } from 'components/Auth'

import {
  NavItemWrapper,
  NavLinkWrapper,
} from './styles'

// NOTE - if requiredGroups is undefined, then we don't check the user's groups.
// otherwise, the user's groups must have at least one match from props.requiredGroups

const NavLink = props => {
  const {
    className,
    children,
    requiredGroups,
    to,
  } = props

  const {
    groups,
    user,
  } = useContext(AuthContext)

  const renderLink = user && (!requiredGroups || requiredGroups.some(g => groups.includes(g)))

  return (
    renderLink &&
    <NavItemWrapper className={className}>
      <NavLinkWrapper
        tag={Link}
        to={to}>
        {children}
      </NavLinkWrapper>
    </NavItemWrapper>
  )
}

NavLink.propTypes = {
  className: string,
  children: node.isRequired,
  requiredGroups: array,
  to: string.isRequired,
}

export default NavLink
